export default __webpack_public_path__ + "static/media/marketing-mobi1.e434b9ad.png";